import { API_OPTIONS } from "./constants";

const OMDB_KEY = process.env.REACT_APP_OMDB_KEY;

const OMDB_QUERIES = {
  now_playing: "avengers",
  popular: "batman",
  top_rated: "godfather",
  upcoming: "mission",
};

const mapOmdbItem = (item) => ({
  id: item.imdbID,
  original_title: item.Title,
  title: item.Title,
  overview: "",
  year: item.Year,
  poster_path: item.Poster && item.Poster !== "N/A" ? item.Poster : null,
});

const withTimeout = (promise, ms) =>
  Promise.race([
    promise,
    new Promise((_, reject) =>
      setTimeout(() => reject(new Error("tmdb-timeout")), ms)
    ),
  ]);

export const searchMovieWithFallback = async (movieName) => {
  const tmdbUrl = `https://api.themoviedb.org/3/search/movie?query=${encodeURIComponent(movieName)}&include_adult=false&language=en-US&page=1`;
  try {
    const res = await withTimeout(fetch(tmdbUrl, API_OPTIONS), 2000);
    if (!res.ok) throw new Error("tmdb-bad-status");
    const json = await res.json();
    if (!json?.results?.length) throw new Error("tmdb-empty");
    return json.results;
  } catch {
    const r = await fetch(`https://www.omdbapi.com/?s=${encodeURIComponent(movieName)}&apikey=${OMDB_KEY}`);
    const j = await r.json();
    return (j.Search || []).map(mapOmdbItem);
  }
};

export const fetchMoviesWithFallback = async (tmdbUrl, category) => {
  try {
    const res = await withTimeout(fetch(tmdbUrl, API_OPTIONS), 2000);
    if (!res.ok) throw new Error("tmdb-bad-status");
    const json = await res.json();
    if (!json?.results?.length) throw new Error("tmdb-empty");
    return json.results;
  } catch {
    const q = OMDB_QUERIES[category] || "movie";
    const r = await fetch(`https://www.omdbapi.com/?s=${q}&apikey=${OMDB_KEY}`);
    const j = await r.json();
    return (j.Search || []).map(mapOmdbItem);
  }
};